import React from 'react';
import { WorkflowEditHookProps } from './useWorkflowEdit';

export const WorkflowEditorContext = React.createContext({} as WorkflowEditHookProps);
